import { InterconsultaCreate } from "./InterconsultaCreate";
import { useLoaderData, useParams } from "react-router-dom";
import { useState } from "react";
import Select from 'react-select'

import * as API from "../services/interconsulta";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getInterconsultaByID(params.interconsultaId);
}


export function InterconsultaEdit() {
  const interconsulta = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [interResp, setInterResp] = useState("");
  const [metaFecha, setInterFecha] = useState("");
  const [interAsu, setInterAsu] = useState("");
  const [interDest, setInterDest] = useState("");
  const [interObs, setInterObs] = useState("");
  const [interFile, setInterFile] = useState("Ningún archivo adjunto");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const options = [
    { value: 'Médico | Dr. Martínez', label: 'Médico | Dr. Martínez' },
    { value: 'Psicóloga | Dra. Jato ', label: 'Psicóloga | Dra. Jato' },
    { value: 'Nutrición | M. López', label: 'Nutrición | M. López' },
    { value: 'Entrenamiento | R. Saura', label: 'Entrenamiento | R. Saura' },
    { value: 'Mindfulness | H. Robledo', label: 'Mindfulness | H. Robledo' }
  ]

  function handleChange(event) {
    setInterFile(event.target.files[0].name);
  }

  const submitInterconsulta = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      interResp,
      metaFecha,
      interAsu,
      interDest,
      interObs,
      interFile,
      tratamientoId,
      pacienteId
    );
    try {
      await InterconsultaCreate(
      interResp,
      metaFecha,
      interAsu,
      interDest,
      interObs,
      interFile,
      tratamientoId,
      pacienteId
      ).then(
        (val) => {
          window.location.replace(
            `../interconsulta/${val.id}`
          );
          // navigate(`../${tratamientoId}/interconsulta/${val.id}`); Reload is needed to update the Menu item List
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        <form id='formNewElement' onSubmit={submitInterconsulta}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='interResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='interResp'
                  required
                  type='text'
                  value={interResp}
                  onChange={(e) => setInterResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setInterFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='interAsu'>Asunto</label>
              <div className='control'>
                <input
                  className='input'
                  id='interAsu'
                  required
                  type='text'
                  value={interAsu}
                  onChange={(e) => setInterAsu(e.target.value)}
                  
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='interDest'>Destinatarios</label>
              <div className='control'>
                <Select
                  isMulti
                  name="colors"
                  options={options}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Seleccionar destinatarios"
                  onChange={(e) => setInterDest(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='interObs'>Mensaje</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='interObs'
                id='interObs'
                value={interObs}
                onChange={(e) => setInterObs(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="field file has-name">
            <label htmlFor='interFile' className="file-label">
              <input
              className="file-input"
              type="file" 
              name="interFile"
              onChange={handleChange}
              />
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload"></i>
                </span>
                <span className="file-label">
                  Seleccionar archivo…
                </span>
              </span>
              <span className="file-name">
              {interFile}
              </span>
            </label>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button className='button is-link' form='formNewElement' type='submit'>
          Guardar
        </button>
      </div>
    </>
  );

  
}
